import { render, staticRenderFns } from "./productRecommendSetting.vue?vue&type=template&id=c3d29326&scoped=true&"
import script from "./productRecommendSetting.vue?vue&type=script&lang=js&"
export * from "./productRecommendSetting.vue?vue&type=script&lang=js&"
import style0 from "./productRecommendSetting.vue?vue&type=style&index=0&id=c3d29326&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3d29326",
  null
  
)

export default component.exports